var exports = {
  "e6": "AddFavoriteChannelModal.module__selectContainer___bEczSE",
  "yc": "AddFavoriteChannelModal.module__checkboxRow___bEczSE",
  "Dq": "AddFavoriteChannelModal.module__checkboxText___bEczSE",
  "gs": "AddFavoriteChannelModal.module__scrollerContainer___bEczSE",
  "o5": "AddFavoriteChannelModal.module__channelList___bEczSE",
  "p$": "AddFavoriteChannelModal.module__emptyState___bEczSE",
  "Km": "AddFavoriteChannelModal.module__categoryHeader___bEczSE",
  "WG": "AddFavoriteChannelModal.module__channelRow___bEczSE",
  "uM": "AddFavoriteChannelModal.module__channelIconContainer___bEczSE",
  "p": "AddFavoriteChannelModal.module__channelIcon___bEczSE",
  "HA": "AddFavoriteChannelModal.module__channelName___bEczSE",
  "tN": "AddFavoriteChannelModal.module__channelActions___bEczSE",
};

module.exports = exports;
